// extracted by mini-css-extract-plugin
export default {"container":"IframeRedirect-module--container--8b70e","button":"IframeRedirect-module--button--588b6","notice":"IframeRedirect-module--notice--eaa81"};